import { atom } from 'jotai';

import APP_CONFIG from '@/configs/app-config';
import { type ListingCardView } from '@/features/listing/types/listing-types';

export const listingsViewAtom = atom<ListingCardView>(APP_CONFIG.defaultListingCardView);
